import clsx from "clsx";

import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import { locations } from "@/features/job/const/locations";
import {
  JobOrderByWithRelationInput,
  JobWhereInput,
} from "@/generated/graphql-hooks";

export const JobLocationFilter = () => {
  const { query, setWhere } = useRequestQuery<
    JobWhereInput,
    JobOrderByWithRelationInput
  >();

  return (
    <div className="space-y-3">
      {Object.keys(locations).map((location, index) => {
        const selected = query?.where?.location?.in?.includes(location);

        return (
          <button
            className={clsx(
              "border-primary mr-3 rounded-full border px-2.5 py-1.5 text-base font-normal",
              selected
                ? "border-primary ring-primary text-primary ring-1"
                : "border-gray-400 text-gray-700",
            )}
            onClick={() => {
              const locations = query.where?.location?.in ?? [];

              if (!locations?.includes(location)) {
                locations.push(location);
              } else {
                locations.splice(locations.indexOf(location), 1);
              }

              setWhere({
                ...query.where,
                location: { in: locations },
              });
            }}
            key={index}
          >
            {locations[location]}
          </button>
        );
      })}
    </div>
  );
};
